import { useLocation } from "#src/components/Router.tsx";
import { useStore } from "#src/stores/Store.tsx";
import {
  SwimAmericaDomains,
  showWideContainer,
  swimAmericaHideHeader,
} from "#src/utils/constants.ts";
import { hideHeader } from "#src/utils/hideHeader.ts";
import { useMediaQueries } from "#src/utils/useMediaQueries.tsx";

interface Props {
  cartOpen?: boolean;
  className?: string;
  isSuperAdmin?: boolean;
  isViewingAs?: boolean;
  children: any;
}

export default function Main(props: Props) {
  const store = useStore();
  const location = useLocation();
  const { small, print } = useMediaQueries();

  let marginTop = 50;
  let paddingBottom = "0rem";

  const isWide = showWideContainer.some((regex) =>
    regex.test(location.pathname)
  );

  if (props.cartOpen) {
    marginTop += 44;
  }

  if (
    hideHeader.some((regex) => regex.test(location.pathname)) ||
    (SwimAmericaDomains.includes(store.organization.subdomain) &&
      swimAmericaHideHeader.some((regex) => regex.test(location.pathname)))
  ) {
    marginTop = 0;
  }

  if (props.isSuperAdmin) {
    marginTop += 30;
  }

  if (props.isViewingAs) {
    marginTop += 30;
  }

  if (location.pathname.includes("/admin/schedule") && !small) {
    marginTop += 60;

    if (location.pathname.includes("/admin/schedule/month")) {
      marginTop += 30;
    }
  }

  if (isWide) {
    paddingBottom = "0";
  }

  if (print) {
    marginTop = 0;
    paddingBottom = "0";
  }

  return (
    <section
      className={props.className}
      style={{
        paddingBottom,
        marginTop,
      }}
      id="main"
    >
      {props.children}
    </section>
  );
}
